import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-130" data-mp="128fnvds7g3t2">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-131" data-mp="xa4ibf8y0fgn">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-132" data-mp="sb1efy4p8fa9">
          <div className="inline-block px-3 py-1 rounded-full border border-aqua bg-white text-navy font-bold text-[10px] sm:text-sm tracking-widest whitespace-nowrap mb-4 sm:mb-6" data-id="element-133" data-mp="3d1a4za4glt8j">
            SCUBA DIVING INSTRUCTOR READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-extrabold leading-tight mb-4 sm:mb-6 text-navy uppercase" data-id="element-134" data-mp="3j925dog4jqvj">
            Solve <span className="text-cta" data-id="element-135" data-mp="39al9qe68qo35">Months of Scuba Lesson Planning</span> in Just{' '}
            <span className="text-cta" data-id="element-136" data-mp="3e9fpt8ctpyjk">5 Minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-4xl mb-4 sm:mb-6" data-id="element-137" data-mp="3eb9150ydt6xw">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-138" data-mp="2qlocq2jglhh8" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-139" data-mp="2hkgh5s8buuqu">
          <p className="text-sm sm:text-lg md:text-xl text-ink leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-140" data-mp="s3mf683jc910">
            The Complete 6-in-1,{' '}
            <span className="font-semibold text-navy" data-id="element-141" data-mp="ibyo48aw4u02">100% Visual Scuba Teaching System</span> with{' '}
            <span className="font-semibold text-navy" data-id="element-142" data-mp="ddnh05bzcxlj">150 Ready-to-Teach Lessons</span>, 6 Complete
            Volumes and 5 Professional Bonus Guides — Ready to Open and Use with Your Students.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-ocean mb-5 sm:mb-7" data-id="element-143" data-mp="161ja702cc7dk">
            100% VISUAL · BEGINNER TO ADVANCED · READY TO TEACH
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-144" data-mp="x14kzpm9a84s">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-145" data-mp="x0uw65cy670o">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700 mb-3" data-id="element-146" data-mp="1xa41v91w2agz">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-147" data-mp="218jvvwwe0j3w">
                <CheckCircle size={14} className="text-ocean" data-id="element-148" data-mp="268g2m3wgyon5" />
                <span className="font-medium" data-id="element-149" data-mp="2b1932fkwnatf">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-slate-500" data-id="element-150" data-mp="2g0lqp2jlolx2">
            6 Complete Volumes · 150 Ready-to-Teach Lessons · 5 Professional Bonus Guides
          </p>
        </motion.div>
      </div>
    </section>;
}